export type OrderStatus = "Enviado" | "Concluído" | "Cancelado";

export const ORDER_STATUSES: OrderStatus[] = [
	"Enviado",
	"Concluído",
	"Cancelado",
];

export const statusColor: Record<OrderStatus, "primary" | "success" | "error"> =
	{
		Enviado: "primary",
		Concluído: "success",
		Cancelado: "error",
	};
